require('./style.scss');
import {E3CloseButton} from '../ui';
import FlagList from './flag-list';
import { resolveNarrationLang } from './lang-map';
import TransparentCanvas from './transparent-canvas';
import EventEmitter from '../helpers/EventEmmiter';
import storage from '../storage/sessionStorage';
import Caption from './caption';

// const json = {
//     "narration": {
//         "001": {
//             "lang": {
//                 "en": "https://gport.s3.eu-central-1.amazonaws.com/intro_en_v5",
//                 "fr": "https://gport.s3.eu-central-1.amazonaws.com/intro_fr_v5"
//             },
//             "scenes": [
//                 "18328",
//                 "18322"
//             ]
//         },
//         "002": {
//             "lang": {
//                 "en": "https://gport.s3.eu-central-1.amazonaws.com/group_bookings_en_v5",
//                 "fr": "https://gport.s3.eu-central-1.amazonaws.com/group_bookings_fr_v5",
//             },
//             "scenes": [
//                 "18329",
//                 "18322",
//                 "18323",
//                 "18325",
//                 "18327",
//                 "18324"
//             ]
//         },
//         "003": {
//             "lang": {
//                 "en": "https://gport.s3.eu-central-1.amazonaws.com/bar_en_v5",
//                 "fr": "https://gport.s3.eu-central-1.amazonaws.com/bar_fr_v5"
//             },
//             "scenes": [
//                 "18320",
//                 "18321",
//                 "18319",
//                 "18326"
//             ]
//         }
//     }
// }

export default class Narration extends EventEmitter{
    _class = 'narration';
    _node = null;
    _video = null;
    _muted = false;
    _lang = null;
    _flagList = null;
    _transparentCanvas= null;
    _restriction = null;
    _controlsHideMaximize = ['maximize', 'pause', 'cc', 'restart'];
    _narrationID = null;
    _caption = null;
    _isAudioMode = false;
    _STORAGE_KEY = 'es360_narration_progress';

    constructor(wrapper, {lang, translateService, modalService, mediaService, json}) {
        super();
        this._wrapper = wrapper;
        this._lang = lang;
        this._translateService = translateService;
        this._modalService = modalService;
        this._mediaService = mediaService || null;
        if (this._mediaService) this._mediaService.register('narration', { pause: () => this.pause() });
        this._json = json;
        this._init();
        this._initListeners();
    }

    _initListeners() {
        this.onPlaying = () => {
            if(!this._video.muted){
                this._restriction = false;
                this._modalService.close('startTour');
            }
        }
    }

    _getSavedProgress() {
        return storage.get(this._STORAGE_KEY) || {};
    }

    _saveProgress(narrationID, time, duration) {
        if(!narrationID || !time || time < 1) return;
        if(duration && time >= duration - 0.5) {
            this._markCompleted(narrationID);
            return;
        }
        const data = this._getSavedProgress();
        data[narrationID] = { time: Math.floor(time), duration: Math.floor(duration || 0) };
        storage.set(this._STORAGE_KEY, data);
    }

    _markCompleted(narrationID) {
        const data = this._getSavedProgress();
        data[narrationID] = { completed: true };
        storage.set(this._STORAGE_KEY, data);
    }

    _clearProgress(narrationID) {
        const data = this._getSavedProgress();
        delete data[narrationID];
        storage.set(this._STORAGE_KEY, data);
    }

    _getProgressForNarration(narrationID) {
        const data = this._getSavedProgress();
        return data[narrationID] || null;
    }

    _saveCurrentProgress() {
        if(!this._video || !this._narrationID) return;
        const time = this._video.currentTime;
        const duration = this._video.duration;
        if(time > 1 && duration && time < duration - 0.5) {
            this._saveProgress(this._narrationID, time, duration);
        }
    }

    _onMediaEnded = () => {
        if(this._video && this._narrationID) {
            this._markCompleted(this._narrationID);
        }
    }


    _initPromt() {
        const template = '<button id="narration-prompt">' + this._translateService.translate('Start Tour') + '</button>';

        this._modalService.showCreatedModal('startTour', template, true, {
            'narration-prompt': {
                event: 'click',
                handler: async () => {
                    this._onUserAction();
                }
            }
        });
    }

    _onUserAction = async () => {
        if(this._isMinimaze()) return ;

        await this._playAvatar();
        this._modalService.close('startTour');
        this._restriction = true;
    }

    _isMinimaze() {
        return this._node.classList.contains('minimize');
    }

    _onUserRescrition() {
        this._restriction = false;

        this._fireEvent('on-user-rescrition');
        // this._initPromt();
    }

    onUserMoveMent() {
        if(!this._restriction && this._narrationID) {
            // Don't auto-play if already listened to 100%
            const saved = this._getProgressForNarration(this._narrationID);
            if(saved && saved.completed) return;
            this._onUserAction();
        }
    }

    _toggleMute() {
        if(this._video.muted) {
            this._muted = false
            this._video.currentTime = 0;
        }else{
            this._muted = true
        }

        this._video.muted = this._muted;
        this._setAudioButton();
        this._playAvatar();
    }


    _setPlayButton() {
        const play = this._controls['play'];
        const pause = this._controls['pause'];
        if(!play || !pause) return ;

        if(this._video && !this._video.paused) {
            play.classList.add('hidden');
            pause.classList.remove('hidden');
        } else {
            pause.classList.add('hidden');
            play.classList.remove('hidden');
        }
    }

    _bindMediaEvents(media) {
        // Narration plays before its element is in the DOM, so bind directly.
        if (this._mediaService) this._mediaService.bindElement(media, 'narration');
        media.addEventListener('play', () => this._setPlayButton());
        media.addEventListener('pause', () => this._setPlayButton());
        media.addEventListener('ended', () => this._setPlayButton());
    }

    _setAudioButton() { 
        const mute = this._controls['mute'];
        const unmute = this._controls['unmute'];
        if(!mute || !unmute) return ;

        if(this._video.muted) {
            mute.classList.add('hidden');
            unmute.classList.remove('hidden');
        }else{
            unmute.classList.add('hidden');
            mute.classList.remove('hidden');
        }
    }

    _toggleControl(button) {
        const control = this._controls[button];
        if(control.classList.contains('hidden')) {
            control.classList.remove('hidden');
        }else {
            control.classList.add('hidden');
        }
    }

    _init(){
        const div = document.createElement('div');
        div.classList.add(this._class);

        this._node = div;

        this._createPanel();
        this._close = this._initCloseButton();
        this._caption = new Caption(div);

    }

    _initCloseButton() {
        const close = new E3CloseButton(this._node, {
            classNames: ['absolute-top-right'],
            events: {
                'mousedown': this._minimize.bind(this, true),
                'touchstart': this._minimize.bind(this, true),
            }
        });

        close.show();

        return close;
    }

    _createControl = (callback, classNames, hidden) => {
        const el = document.createElement('button');
        if(Array.isArray(classNames)) {
            classNames.forEach((className) => {
                el.classList.add(`control-${this._class}-${className}`);
            })
            classNames = classNames[0];
        }else{
            el.classList.add(`control-${this._class}-${classNames}`);
        }
        el.classList.add('control');
        if(hidden) el.classList.add(hidden);

        el.addEventListener('click', callback);

        return {
            [classNames]: el
        };
    }

    _updateLang(lang) {
        // this._controls['flag'].classList.remove(`control-${this._class}-${this._lang}`);
        // this._controls['flag'].classList.add(`control-${this._class}-${lang}`);

        this._lang = lang;
    }

    updateLang(lang) {
        if (!this._narrationID || !this._json.narration[this._narrationID]) return;
        const available = Object.keys(this._json.narration[this._narrationID].lang);
        const resolved = resolveNarrationLang(lang, available);

        this._muted = false;
        this._updateLang(resolved);
        this.removeVideo();
        this.init();
        // this.flagList = this.flagList.destroy();
    }

    _changeLang() {
        if(this.flagList) return this.flagList = this.flagList.destroy();

        const flagList = new FlagList(this._controls['flag'], [...Object.keys(this._json.narration[this._video.dataset.narrationID].lang)]);
        // flagList.show();
        flagList.on('onChooseLang', (lang) => {
            this._muted = false;
            this._updateLang(lang)
            this.removeVideo();
            this.init();
            this.flagList = this.flagList.destroy();
        })

        this.flagList = flagList;
    }

    _restart() {
        if(!this._video) return;
        this._video.currentTime = 0;
        this._video.play().catch(e => console.log(e));
    }

    _togglePlay() {
        if(!this._video) return;

        if(!this._video.paused) {
            this._video.pause();
        } else {
            this._video.play().then(() => {
            }).catch(e => {
                console.log(e);
            });
        }
    }

    pause() {
        if(!this._video) return;

        this._video.pause();
    }

    _toggleCaptions() {
        if(!this._caption) return;
        const enabled = this._caption.toggle();
        const cc = this._controls['cc'];
        if(cc) cc.classList.toggle('cc-active', enabled);
    }

    async _loadCaptions(langData) {
        if(!this._caption || !this._video) return;
        const cc = this._controls['cc'];

        if(langData && langData.caption) {
            await this._caption.load(langData.caption);
            this._caption.attach(this._video);
            if(cc) {
                cc.classList.remove('hidden');
                cc.classList.remove('cc-active');
            }
        } else {
            this._caption.detach();
            this._caption.hide();
            if(cc) cc.classList.add('hidden');
        }
    }

    _createPanel = () => {
        const panel = document.createElement('div');
        panel.classList.add('narration-panel');

        const controls = document.createElement('div');
        controls.classList.add('controls');

        const els = {
            // ...this._createControl(() => this._toggleMute(), 'mute', 'hidden'),
            // ...this._createControl(() => this._toggleMute(), 'unmute'),
            ...this._createControl(() => this._togglePlay(), 'play'),
            ...this._createControl(() => this._togglePlay(), 'pause', 'hidden'),
            ...this._createControl(() => this._restart(), 'restart'),
            ...this._createControl(() => this._toggleCaptions(), 'cc', 'hidden'),
            // ...this._createControl(() => this._changeLang(), ['flag', this._lang]),
            ...this._createControl(() => this._maximize(), 'maximize', 'hidden'),
        }

        for(let i in els) {
            controls.append(els[i]);
        }

        this._controls = els;

        panel.append(controls);

        this._node.append(panel);

        return panel;
    }

    _addTransparentCanvas(video) {
        if(this._transparentCanvas) this._transparentCanvas.destroy();

        this._transparentCanvas = new TransparentCanvas(this._node, video);
    }

    _addVideo(url, ext) {
        const source = document.createElement('source');
        let type = `video/${ext}`;
        if(ext === 'mp4') type =  `video/${ext}; codecs="hvc1"`
        source.setAttribute('type', type);
        source.src = `${url}`;

        return source;
    }

    _createAudio = async ({ url, sceneID, narrationID, resumeTime }) => {
        this.removeVideo();
        this._onLoadVideo();
        this._isAudioMode = true;
        this._node.classList.add('audio-mode');

        const audio = document.createElement('audio');
        this._video = audio;

        audio.dataset.sceneID = sceneID;
        audio.dataset.narrationID = narrationID;
        audio.muted = this._muted;
        audio.src = url.audio;
        audio.addEventListener('playing', () => this.onPlaying());
        audio.addEventListener('ended', this._onMediaEnded);
        this._bindMediaEvents(audio);

        if(resumeTime === undefined) {
            audio.setAttribute('autoplay', true);
            try {
                await this._playAvatar();
            } catch(e) {
                console.log(e);
                this._onUserRescrition();
            }
        } else {
            audio.setAttribute('preload', 'metadata');
            await new Promise(resolve => {
                if(audio.readyState >= 1) {
                    audio.currentTime = resumeTime;
                    resolve();
                } else {
                    audio.addEventListener('loadedmetadata', () => {
                        audio.currentTime = resumeTime;
                        resolve();
                    }, { once: true });
                }
            });
        }

        this._onLoadFinishVideo();
        return audio;
    };

    _createVideo = async ({ url, sceneID, narrationID, resumeTime }) => {
        this.removeVideo();
        this._onLoadVideo();

        const video = document.createElement('video');
        this._video = video;

        try {
            video.classList.add('video');

            video.dataset.sceneID = sceneID;
            video.dataset.narrationID = narrationID;
            video.muted = this._muted;

            video.setAttribute('crossorigin', 'anonymous');
            video.setAttribute('webkit-playsinline', 'webkit-playsinline');
            video.setAttribute('playsinline', 'playsinline');

            video.addEventListener('playing', () => this.onPlaying());
            video.addEventListener('ended', this._onMediaEnded);
            this._bindMediaEvents(video);

            video.append(this._addVideo(url.mp4, 'mp4'));
            video.append(this._addVideo(url.webm, 'webm'));

            if(resumeTime === undefined) {
                video.setAttribute('autoplay', true);
                await this._playAvatar();
            } else {
                // Wait for metadata before seeking
                video.setAttribute('preload', 'metadata');
                await new Promise(resolve => {
                    if(video.readyState >= 1) {
                        video.currentTime = resumeTime;
                        resolve();
                    } else {
                        video.addEventListener('loadedmetadata', () => {
                            video.currentTime = resumeTime;
                            resolve();
                        }, { once: true });
                    }
                });
            }
        } catch (e) {
            console.log(e);
            this._onUserRescrition();
        }

        this._onLoadFinishVideo();

        return video;
    };

    _playAvatar = async () => {
        if(!this._video) return ;
        if(this._isMinimaze()) return this.pause();

        try {
            await this._video.play();

            this._setAudioButton();
            if(!this._video.muted) this._restriction = true;
        }catch (e) {
            if(e.name === 'NotAllowedError'){
                console.log(e)
                this._restriction = false;
                // this._toggleMute();
            }

            throw new Error(e);
        }
    }

    getLang(narrationID) {
        const available = Object.keys(this._json.narration[narrationID].lang);
        const resolved = resolveNarrationLang(this._lang, available);
        // resolved is undefined when the narration has no languages at all
        if (resolved && resolved !== this._lang.toLowerCase()) {
            this._updateLang(resolved);
        }
        return resolved;
    }

    init = async (sceneID = this._sceneID, lang = this._lang) => {
        this._sceneID = sceneID;
        this._lang = lang;

        let narrationID = null;

        for(var i in this._json.narration){
            if(this._json.narration[i].scenes.includes(sceneID)){
                narrationID = i;

                break;
            }
        }

        // Same narration still loaded — keep playing, don't interrupt
        if(this._video && this._video.dataset.narrationID == narrationID) {
            this._narrationID = narrationID;
            if(!this._video.paused) {
                // Currently playing — just continue (shared scenes), show progress
                this._saveCurrentProgress();
                this.show();
                return;
            }
            // Same narration across shared rooms — just keep current state, don't restart or auto-play
            this.show();
            return;
        }

        // Different narration or none — save progress from current before switching
        this._saveCurrentProgress();

        this._narrationID = narrationID;

        if(narrationID === null && this._video) this.hide(true);
        if(narrationID === null) {
            if(this._caption) this._caption.hide();
            return;
        }

        const saved = this._getProgressForNarration(narrationID);
        const langData = this._json.narration[narrationID].lang[this.getLang(narrationID)];
        // Narration entry with no uploaded content for any language — skip it
        // instead of crashing the whole tour init.
        if (!langData) return;

        if (saved && saved.completed) {
            // Already listened to 100% — show from beginning but don't auto-play
            const resumeTime = 0;
            if (langData.audio) {
                this._video = await this._createAudio({url: langData, sceneID, narrationID, resumeTime});
            } else {
                this._video = await this._createVideo({url: langData, sceneID, narrationID, resumeTime});
            }
            this._node.append(this._video);
            if(!this._wrapper.contains(this._node)) this._wrapper.appendChild(this._node);
            this._loadCaptions(langData);
            return;
        } else if (saved && saved.time) {
            // Partial progress — auto-play from saved position
            if (langData.audio) {
                this._video = await this._createAudio({url: langData, sceneID, narrationID});
            } else {
                this._video = await this._createVideo({url: langData, sceneID, narrationID});
            }
            this._node.append(this._video);
            if(!this._wrapper.contains(this._node)) this._wrapper.appendChild(this._node);
            this._video.currentTime = saved.time;
        } else {
            // Fresh narration — auto-play from start
            if (langData.audio) {
                this._video = await this._createAudio({url: langData, sceneID, narrationID});
            } else {
                this._video = await this._createVideo({url: langData, sceneID, narrationID});
            }
            this._node.append(this._video);
            if(!this._wrapper.contains(this._node)) this._wrapper.appendChild(this._node);
        }

        this._loadCaptions(langData);
    }

    removeVideo() {
        if(this._caption) this._caption.detach();
        if(this._video) {
            this._video.pause();
            this._video.removeEventListener('playing', () => this.onPlaying());
            this._video.removeEventListener('ended', this._onMediaEnded);
            this._video.remove();
            if(this._transparentCanvas) this._transparentCanvas.hide();
            this._video = null;
        }
        if(this._isAudioMode) {
            this._isAudioMode = false;
            this._node.classList.remove('audio-mode');
        }
    }

    _onLoadVideo() {
        this._node.classList.add("hidden");
    }

    _minimize(){
        const wrapper = this._node;

        wrapper.addEventListener("animationend", () => {
            wrapper.classList.add("minimize-mode");
        }, { once: true });

        const maximize = this._controls['maximize'];
        const node = this._node;
        const video = this._video;
        if(!maximize) return ;

        this.pause();
        if(this._caption) this._caption.hide();
        node.classList.add('minimize');

        for(let i in  this._controls){
            if(i === 'maximize') {
                this._controls[i].classList.remove("hidden"); 
                continue ;
            }

            this._controls[i].classList.add("hidden"); 
        }
    }

    _updateFlag() {
        const langs = [...Object.keys(this._json.narration[this._video.dataset.narrationID].lang)];
        const flag = this._controls['flag'];

        if(langs.length === 1) {
           flag.classList.add('hidden');
        }else {
            flag.classList.remove('hidden');
        }
    }

    _maximize(){
        const maximize = this._controls['maximize'];
        const node = this._node;
        if(!maximize) return ;

        node.classList.remove('minimize');
        node.classList.remove('minimize-mode');
        if(this._caption) this._caption.show();
        this._playAvatar();

        for(let i in  this._controls){
            if(this._controlsHideMaximize.includes(i)) {
                this._controls[i].classList.add("hidden"); 
                continue ;
            }

            this._controls[i].classList.remove("hidden"); 
        }
    }

    _onLoadFinishVideo() {
        this._node.classList.remove("hidden");        
    }

    isHidden(){
        return this._node.classList.contains("hidden");
    }

    playBack(){
        if(!this._narrationID) return;
        const saved = this._getProgressForNarration(this._narrationID);
        if(saved && saved.completed) {
            this.show();
            return;
        }
        this._playAvatar();
        this.show();
    }

    hide(stop=false){
        if(stop) {
            this._saveCurrentProgress();
            this._video.currentTime = 0;
        }
        this._node.classList.add("hidden");
        if(this._caption) this._caption.hide();

        this.pause();
    }

    show(){
        this._node.classList.remove("hidden");
        if(this._caption && this._caption.isEnabled()) this._caption.show();
    }

    applyClass(className){
        this._node.classList.add(className);
    }

    destroy(){
        this._saveCurrentProgress();
        if(this._caption) this._caption.destroy();
        this.removeVideo();
        if(this._mediaService) this._mediaService.unregister('narration');
        if(this._node && this._node.parentNode === this._wrapper) this._wrapper.removeChild(this._node);
    }
}


